"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var CoreContext_1 = __importDefault(require("./CoreContext"));
var useCore = function () { return (0, react_1.useContext)(CoreContext_1.default); };
exports.default = useCore;
